import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/testimonials-section.tsx");
